const ClipLoader
= ({ size = 3.5, color = "#6ac3db" }) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: "60vh" }}
    >
      <div
        className="spinner-border"
        style={{ width: `${size}rem`, height: `${size}rem`, color: color }}
        role="status"
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default ClipLoader
;
